import { render, staticRenderFns } from "./LoadingEffect2.vue?vue&type=template&id=0321c38a&scoped=true&"
import script from "./LoadingEffect2.vue?vue&type=script&lang=js&"
export * from "./LoadingEffect2.vue?vue&type=script&lang=js&"
import style0 from "./LoadingEffect2.vue?vue&type=style&index=0&id=0321c38a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0321c38a",
  null
  
)

export default component.exports